import { mobile } from '../../../mediaQueries'

const styles = theme => ({
    '@global': {
        '.swiper-button-next,.swiper-button-prev': {
            display: 'none'
        },
        '.swiper-slide': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            opacity: 0.5,
            transition: 'opacity 2s, transform 1s',
            margin: '0 30px',
            [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
                marginBottom: '30px !important',
                marginTop: '20px !important',
                height: 'min-content'
            }
        },
        '.swiper-wrapper': {
            maxWidth: '90vw',
            position: 'relative'
        },
        '.swiper-slide-active': {
            opacity: 1,
            transform: 'scale(1.1)',
            transition: 'transform 1s .5s',
            transformOrigin: 'center',
            [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
                transform: 'scale(1)'
            }
        }
    },
    scrollBarWrap: {
        width: '100%',
        margin: 'auto',
        borderRadius: '8px',
        backgroundColor: '#F6F3EF',
        height: '8px !important',
        maxWidth: '400px',
        position: 'relative'
    },
    scrollDrag: {
        height: '8px',
        transition: 'all 1.3s',
        backgroundColor: '#0045EA',
        borderRadius: '8px',
        maxWidth: '100px',
        position: 'absolute'
    },
    swiper: {
        width: '100%'
    },
    span: {
        maxHeight: '450px',
        width: 'fit-content',
        marginBottom: '80px',
        marginTop: '102px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    slideText: {
        fontFamily: 'Playfair Display',
        margin: '0',
        fontWeight: '600',
        color: '#989994',
        fontSize: '20px',
        whiteSpace: 'pre',
        lineHeight: '28px',
        textAlign: 'center',
        letterSpacing: '0.02em',
        [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
            lineHeight: '28px',
            color: '#575452'
        }
    },
    slideImg: {
        marginBottom: '2rem',
        maxHeight: '400px',
        zIndex: 10,
        boxShadow: '0px 8px 30px rgba(0, 0, 0, 0.2)',
        [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
            maxHeight: '260px',
            maxWidth: '90vw',
            objectFit: 'cover'
        }
    },
    leftDiv: {
        background: '-webkit-linear-gradient(0turn, #FFFFFF 0%, rgba(255,255,255,0.001) 100%);',
        position: 'absolute',
        right: 'calc(95% + 2px)',
        zIndex: '10',
        top: '0',
        height: '100%',
        width: '5%'
    },
    rightDiv: {
        background: '-webkit-linear-gradient(0.5turn, #FFFFFF 0%, rgba(255,255,255,0.001) 100%);',
        position: 'absolute',
        left: 'calc(95% + 2px)',
        zIndex: '10',
        top: '0',
        height: '100%',
        width: '5%'
    }
})

export default styles